import { useState } from "react";
import { motion } from "framer-motion";
import { Ghost, Music, Play } from "lucide-react";
import { ASSETS } from "@/data/magicalContent";
import { MediaPlayerModal } from "@/components/magical/MediaPlayerModal";

const HALLOWEEN_ART = "https://customer-assets-lxgj4vgw.emergentagent.net/job_magical-niyati-shivu/artifacts/2cb0fd3d1dde655f_39.png";
const HALLOWEEN_SONG = { episodeNumber: 0, label: "Halloween Special", title: "Happy Halloween Song", youtubeId: "Htg3m88h9K8", mediaKey: "song-halloween" };

export function SongSection() {
  const [halloweenOpen, setHalloweenOpen] = useState(false);
  return (
    <section id="songs" className="ns-section ns-songs" data-testid="songs-section">
      <motion.div className="ns-song-feature" initial={{ opacity: 0, y: 34 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
        <div className="ns-song-art"><img src={ASSETS.family} alt="Niyati and Shivu Season 1 song artwork" /><span><Music size={16} /> Official song</span></div>
        <div className="ns-song-copy">
          <p className="ns-kicker">Season 1 · Songs</p>
          <h2>Welcome to the<br /><em>magical world.</em></h2>
          <p>The official Niyati &amp; Shivu welcome song from Season 1, ready for little dreamers to sing along.</p>
          <audio data-testid="season-one-song-player" src="/official-song.mp3" controls preload="metadata" />
          <a className="ns-text-link" href="/season-1" data-testid="season-one-song-link"><Play size={15} /> Explore Season 1</a>
        </div>
      </motion.div>
      <motion.div className="ns-song-special" data-testid="halloween-song-card" initial={{ opacity: 0, y: 34 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
        <button type="button" className="ns-song-special-art" data-testid="halloween-play-button" onClick={() => setHalloweenOpen(true)} aria-label="Play the Happy Halloween song">
          <img src={HALLOWEEN_ART} alt="Niyati, Shivu and Buddy celebrating Halloween" loading="lazy" />
          <span className="ns-song-special-play"><Play size={26} fill="currentColor" /></span>
        </button>
        <div className="ns-song-copy">
          <p className="ns-kicker"><Ghost size={14} /> Special treat</p>
          <h2>Happy<br /><em>Halloween!</em></h2>
          <p>Niyati, Shivu and Buddy dressed up for a spooky-sweet celebration. Tap the picture to play the Halloween song right here.</p>
          <button type="button" className="ns-button ns-button-primary" data-testid="halloween-play-cta" onClick={() => setHalloweenOpen(true)}><Play size={15} fill="currentColor" /> Play Halloween song</button>
        </div>
      </motion.div>
      {halloweenOpen && <MediaPlayerModal kind="song" items={[HALLOWEEN_SONG]} startIndex={0} onClose={() => setHalloweenOpen(false)} />}
    </section>
  );
}
